// extracted by mini-css-extract-plugin
module.exports = {"revision-list":"zWi_J","revisionList":"zWi_J"};